import { forwardRef, type HTMLAttributes } from "react";
import styled from "@emotion/styled";
import type { CSSObject } from "@emotion/react";

export type ContainerSize = "sm" | "md" | "lg" | "full";

interface ContainerOwnerState {
  size: ContainerSize;
}

/* Exact compiled output of the pre-migration Tailwind utilities
 * (base → size), verified against the frozen baseline. */

const containerBase: CSSObject = {
  marginLeft: "auto",
  marginRight: "auto",
  width: "100%",
  paddingLeft: "1.25rem",
  paddingRight: "1.25rem",
  "@media (min-width:640px)": {
    paddingLeft: "2rem",
    paddingRight: "2rem"
  }
};

const containerSizeStyles: Record<ContainerSize, CSSObject> = {
  sm: { maxWidth: "48rem" },
  md: { maxWidth: "64rem" },
  lg: { maxWidth: "80rem" },
  full: { maxWidth: "none" }
};

const ContainerRoot = styled("div", {
  label: "AgenticContainer-root",
  shouldForwardProp: (propName) => propName !== "ownerState"
})<{ ownerState: ContainerOwnerState }>(({ ownerState }) => [containerBase, containerSizeStyles[ownerState.size]]);

export type ContainerProps = HTMLAttributes<HTMLDivElement> & {
  size?: ContainerSize | null;
};

export const Container = forwardRef<HTMLDivElement, ContainerProps>(({ className, size, ...props }, ref) => (
  <ContainerRoot ref={ref} ownerState={{ size: size ?? "lg" }} className={className} {...props} />
));

Container.displayName = "Container";
